import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom'
import './Navbar.css';
import '../fonts/Gill Sans Nova Cn Medium.ttf'
import '../fonts/Gill Sans Nova Cn Light.ttf'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import Basket from './basket/Basket';



function Navbar({basket, emptyBasket, removeFromBasket, updateItemBasketQuantity, emptyingBasket }) {
  const [click, setClick] = useState(false);
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null);
  const location = useLocation();

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);


  const toggleDrawer = () => {
      setIsOpen((prevState) => !prevState)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (click && menuRef.current && !menuRef.current.contains(event.target)) {
        closeMobileMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [click]);

  return (
    <>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction='right'
        overlayOpacity='0.9'
        overlayColor='#fff'
      >
      <Basket basket={basket} emptyBasket={emptyBasket} removeFromBasket={removeFromBasket} updateItemBasketQuantity={updateItemBasketQuantity} toggleDrawer={toggleDrawer} emptyingBasket={emptyingBasket}/>
      </Drawer>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-title' onClick={() => {
            window.scroll(0, 0);
            closeMobileMenu()
          }}>CHATTERS</Link>
          <div className='navbar-logo'></div>
          {location.pathname.includes('market') &&          //this should be 'checkout'
          <>
            <img
                className='basket_icon'
                alt='Basket Icon'
                src={require('./../images/basket_icon.png')}
                loading="eager"
                onClick={toggleDrawer}
            />
            <span className='basket_size'>{basket?.lines?.edges?.reduce((acc, { node }) => acc + node.quantity, 0)}</span>
          </>
          }
          <div className={click ? 'menu-btn open' : 'menu-btn'} onClick={handleClick}>
            <div className='menu-btn__burger'></div>
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'} ref={menuRef}>
          <li className='nav-item'>
            <Link  
              to='/' 
              className='nav-links' 
              onClick={() => {closeMobileMenu(); window.scroll(0, 0);}}
              >
              HOME
            </Link>
            </li>
            <li className='nav-item'>
            <Link  
              to='/restaurant' 
              className='nav-links' 
              onClick={() => {closeMobileMenu(); window.scroll(0, 0);}}
              >
              RESTAURANT
            </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/catering'
                className='nav-links'
                onClick={() => {closeMobileMenu(); window.scroll(0, 0);}}
              >
                CATERING
              </Link>
            </li>
            {/*<li className='nav-item'>*/}
            {/*  <Link*/}
            {/*      to='/market'*/}
            {/*      className='nav-links'*/}
            {/*      onClick={() => {closeMobileMenu(); window.scroll(0, 0);}}*/}
            {/*  >*/}
            {/*    MARKET*/}
            {/*  </Link>*/}
            {/*</li>*/}
            <li className='nav-item'>
            <a href='https://squareup.com/gift/MLNJEJHJ7K2HG/order' target='_blank' rel="noreferrer" className='nav-links'>VOUCHERS</a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
